/* eslint-disable max-len */
import React from 'react';
import { CatalogSource } from '@1po/1po-bff-fe-spec/generated/common/vehicle/CatalogSource';
import styled from 'styled-components';
import { Image, URL } from 'UI';

const ThumbnailCardButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 2px solid ${({ $active, theme }) => ($active ? theme.color.clear_blue : theme.color.grey90)};
  border-radius: 2px;
  background: ${({ theme }) => theme.color.grey95};
  padding: 0;
  cursor: pointer;
  overflow: hidden;

  :hover {
    box-shadow: 0 4px 6px ${({ theme }) => theme.color.shadow_8};
  }
`;

const RenderImage = ({
  imageKey,
  catalogSource,
  selectedIndex,
}: {
  imageKey: string;
  catalogSource: CatalogSource;
  selectedIndex: number;
}) => {
  return (
    <Image
      src={imageKey}
      type={URL}
      catalogSource={catalogSource}
      alt={`product-thumbnail-${selectedIndex}`}
      maxHeight={'96px'}
      maxWidth={'96px'}
      fallbackComponent={<Image alt={'default-product-thumbnail'} src={'catalog/product-placeholder.jpg'} />}
    />
  );
};

export const ProductThumbnailCard = ({
  imageKey,
  active,
  onClick,
  index,
  catalogSource,
}: {
  imageKey: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  active: boolean;
  index: number;
  catalogSource: CatalogSource;
}) => {
  return (
    <ThumbnailCardButton
      $active={active}
      className={'product_id' + index}
      onClick={onClick}
      type={'button'}
      data-testid={`product-image-thumbnail-${index}`}
    >
      <RenderImage imageKey={imageKey} selectedIndex={index} catalogSource={catalogSource} />
    </ThumbnailCardButton>
  );
};
